import React from "react";
import UnitGenericSkeleton from "./UnitGenericSkeleton";

function UnitDetailSkeleton() {
  return (
    <>
      <UnitGenericSkeleton />
    </>
  );
}

export default UnitDetailSkeleton;
